import React from 'react';
import { AgFinancingFile, Phase3 } from '@indigo-ag/schema';
import { Body, ReadOnlyField } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { DocumentCard, PhaseSection, utils } from 'shared';

interface MinutaSectionProps {
  registrationNumber: Phase3['draftRegistrationNumber'];
  minutaFile?: AgFinancingFile;
}

export const MinutaSection: React.FunctionComponent<MinutaSectionProps> = ({ registrationNumber, minutaFile }) => {
  return (
    <PhaseSection title={i18next.t('cpr')}>
      <div className="flex">
        {minutaFile ? (
          <>
            <DocumentCard document={minutaFile} classes={{ documentCard: 'mr-4' }} />
            <ReadOnlyField label={i18next.t('registrationNumber')} value={registrationNumber || '-'} />
          </>
        ) : (
          <Body>{utils.text.firstLetterUppercase(i18next.t('noRegisteredMinutaMessage'))}</Body>
        )}
      </div>
    </PhaseSection>
  );
};
